import { render } from "./ExportableTable.vue?vue&type=template&id=45310d55&scoped=true"
import script from "./ExportableTable.vue?vue&type=script&lang=js"
export * from "./ExportableTable.vue?vue&type=script&lang=js"

import "./ExportableTable.vue?vue&type=style&index=0&id=45310d55&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45310d55"]])

export default __exports__